module.exports = __webpack_public_path__ + "img/j.f3715326.jpg";